<mat-nav-list role="list">
  <div *ngFor="let item of menuItems; let i = index">
    <ng-container *ngIf="!item.isVisible$ || (item.isVisible$ | async)">
      <!-- links and submenus -->
      <mat-list-item
        *ngIf="item.type !== MenuItemType.Separator"
        class="sidebar-list-item"
        role="listitem"
        routerLinkActive="highlighted"
        ix-auto
        ix-auto-type="option"
        id="nav-{{ i }}"
        ix-auto-identifier="{{ item.name }}"
        [class.has-submenu]="item.type === MenuItemType.SlideOut"
        [class.highlighted]="isHighlighted === item.state"
        (click)="updateHighlightedClass(item.state)"
      >
        <a
          *ngIf="item.type === MenuItemType.Link"
          class="sidenav-link"
          [routerLink]="getRouterLink(item.state)"
          [name]="getItemName(item)"
          (click)="closeMenu()"
        >
          <span
            class="menu-item-tooltip"
            matTooltipPosition="right"
            [matTooltip]="item.tooltip | translate"
            [id]="item.name"
          ></span>
          <ix-icon [name]="item.icon"></ix-icon>
          <span>{{ item.name | translate }}</span>
        </a>
        <a
          *ngIf="item.type === MenuItemType.SlideOut"
          class="sidenav-link"
          tabindex="0"
          [name]="getItemName(item)"
          (click)="toggleMenu(item.state, item.sub)"
          (keyup.enter)="toggleMenu(item.state, item.sub)"
        >
          <span
            class="menu-item-tooltip"
            matTooltipPosition="right"
            [matTooltip]="item.tooltip | translate"
          ></span>
          <ix-icon [name]="item.icon"></ix-icon>
          <span>{{ item.name | translate }}</span>
          <span fxFlex></span>
          <ix-icon class="menu-caret">keyboard_arrow_right</ix-icon>
        </a>

        <a
          *ngIf="item.type === MenuItemType.ExternalLink"
          target="_blank"
          class="sidenav-link"
          [href]="item.state"
          [name]="getItemName(item)"
        >
          <span
            class="menu-item-tooltip"
            matTooltipPosition="right"
            [matTooltip]="item.tooltip | translate"
          ></span>
          <ix-icon [name]="item.icon"></ix-icon>
          <span>{{ item.name | translate }}</span>
        </a>
      </mat-list-item>

      <div *ngIf="item.type === MenuItemType.Separator" class="mt-1 mb-1">
        <mat-divider></mat-divider>
        <span *ngIf="item.name" class="nav-section-title text-muted">
          {{ item.name | translate }}
        </span>
      </div>

      <a mat-button class="absorbs-focus" [tabIndex]="-1">
        <!-- 'absorbs' the focus behavior -->
      </a>
    </ng-container>
  </div>
</mat-nav-list>
